const tr = {
  header: {
    selectLanguage: "Dil seçin",
    languages: "Diller",
  },
  hero: {
    tagline: "GODO DEMO İŞLEM YARIŞMASI",
    title: "İşlem Becerilerinizi Gösterin, Gerçek Ödüller Kazanın!",
    subtitle:
      "GODO Demo İşlem Yarışması’na katılın, {balance} demo bakiyeyle işlem yapın, diğer yatırımcıları geride bırakın ve ödül havuzundan payınızı alın!",
    participateNow: "Şimdi Katıl",
    seeHowItWorks: "Nasıl Çalışır",
    trophiesAlt: "Yarışma kupaları",
  },
  countdown: {
    competitionStart: "Yarışma Başlangıcına Kalan Süre",
    startedAt: "{date}",
    competitionEnds: "Yarışma Bitişine Kalan Süre",
    endsAt: "{date}",
    days: "Gün",
    hours: "Saat",
    minutes: "Dakika",
    seconds: "Saniye",
  },
  prizes: {
    title: "Ödüller",
    subtitle:
      "Doğrulanmış üst hesaplar, yarışma sonunda {prizePool} USD ödül havuzunu paylaşır.",
    totalPrizePool: "Toplam Ödül Havuzu",
    firstPlace: "1. Sıra",
    secondPlace: "2. Sıra",
    thirdPlace: "3. Sıra",
    fourthPlace: "4. Sıra",
    fifthPlace: "5. Sıra",
    fivthPlace: "5. Sıra",
    sixthPlace: "6. Sıra",
    seventhPlace: "7. Sıra",
    duration: "Süre",
    durationDay: "1 Gün",
    durationDays: "{count} Gün",
    durationWeek: "1 Hafta",
    durationWeeks: "{count} Hafta",
    durationMonth: "1 Ay",
    durationMonths: "{count} Ay",
    startingBalance: "Başlangıç Bakiyesi",
    entry: "Katılım",
    entryValue: "Ücretsiz",
    accounts: "Hesaplar",
    accountsValue: "Yatırımcı başına 1",
  },
  leaderboard: {
    title: "Sıralama",
    rank: "Sıra",
    trader: "Yatırımcı",
    equity: "Özkaynak",
    profitLoss: "Kâr / Zarar",
    margin: "Performans %",
    drawdown: "Düşüş %",
    status: "Durum",
    reason: "Neden",
    statusActive: "Aktif",
    statusPending: "Beklemede",
    statusDisqualified: "Diskalifiye",
    reasonNone: "—",
    reasonDrawdown: "Zirveden %30 veya üzeri düşüş",
    reasonLeftGroup: "Yarışma grubundan ayrıldı",
    rankUp: "Sıra yükseldi",
    rankDown: "Sıra düştü",
    previous: "Önceki",
    next: "Sonraki",
    previousPage: "Önceki sayfa",
    pagination: "Lider tablosu sayfaları",
    nextPage: "Sonraki sayfa",
    mt5Login: "MT5 {login}",
    loading: "Canlı sıralama yükleniyor…",
    empty: "Henüz yarışma hesabı yok. MT5 demo hesapları yarışma grubuna katılınca sıralama görünür.",
    loadError: "Canlı sıralama yüklenemedi. Lütfen kısa süre sonra tekrar deneyin.",
    winnersTitle: "Kazananlar",
    winnersSubtitle: "Ödül sıralaması sahnede — yarışma kapanışında kilitlendi.",
    verified: "Doğrulandı",
    amount: "Tutar",
    topTradersTitle: "En İyi Yatırımcılar",
    topTradersSubtitle: "Ödüle uygun güncel liderler sahnede.",
  },
  steps: {
    title: "Başlamak İçin Dört Adım",
    nextStep: "Sonraki adım",
    items: [
      {
        title: "Kayıt ve Doğrulama",
        description:
          "Hesabınızı hızlı ve güvenli açın. Sade doğrulama süreci sizi günler değil dakikalar içinde işleme hazırlar.",
      },
      {
        title: "Fonlama",
        description:
          "Tercih ettiğiniz yöntemle yatırım yapın ve tüm enstrümanların açık olduğu işlem ortamına anında erişin.",
      },
      {
        title: "Ay Boyunca İşlem Yapın",
        description:
          "Rekabetçi ECN fiyatları ve yüksek hızla MT4, MT5 ve GODO Mobil Uygulamasında işlem yapın.",
      },
      {
        title: "Kazan ve Çek",
        description:
          "Sıralamada yükselin, ödül havuzundaki payınızı alın ve kazancınızı kolayca çekin.",
      },
    ],
  },
  rules: {
    title: "Resmi Yarışma Kuralları",
    items: [
      {
        title: "Katılım ve Kayıt",
        description:
          "Katılım ücretsizdir, KYC tamamlayın, katılımcı başına bir hesap ve bir IP adresi.",
      },
      {
        title: "İşlem Parametreleri",
        description:
          "Tüm işlemler etkinlik boyunca atanmış {balance} bakiyeli demo hesapta yapılmalıdır.",
      },
      {
        title: "Sıralama ve Değerlendirme",
        description:
          "Sıralama en yüksek kapanış özkaynağına göredir. Beraberlikte daha düşük Maksimum Drawdown % öne geçer.",
      },
      {
        title: "Diskalifiye",
        description:
          "Çoklu hesaplar, haksız uygulamalar, sistem suistimali veya kural ihlalleri diskalifiye sebebidir.",
      },
      {
        title: "Ödül Dağıtımı",
        description:
          "Ödüller KYC’si tamamlanmış doğrulanmış ilk 3 hesaba verilir. Devredilemez.",
      },
      {
        title: "Genel Hükümler",
        description:
          "GODO, yarışmayı dilediği zaman değiştirme, uzatma, erteleme veya iptal etme hakkını saklı tutar.",
      },
    ],
  },
  bottomCta: {
    title: "Üstünlüğünüzü Kanıtlamaya Hazır mısınız?",
    text: "Ücretsiz katılım, sanal sermaye, gerçek ödüller. GODO portalında KYC’nizi tamamlayın ve yarışma hesabınızı alın.",
  },
  footer: {
    qrAlt: "QR kodu",
    showQr: "Uygulama QR kodunu göster",
    playStore: "Google Play’den indirin",
    appStore: "App Store’dan indirin",
    social: "Sosyal bağlantılar",
    scanQr: "GODO uygulamasını indirmek için tarayın",
    copyright: "Telif hakkı © 2026 – Tüm hakları saklıdır",
    regulationLabel: "Düzenleme ve Yetkilendirme:",
    regulationBody:
      "“GODO LTD” (FSC Lisans No GB20025812), Mauritius yasaları uyarınca yetkili ve tescilli bir limited şirkettir. Hesabınızın Finansal Hizmetler Komisyonu (FSC) kurallarına tam uyumla yönetilmesini sağlarız. godocm.com alan adı GODO LTD tarafından işletilir.",
    introductionLabel: "GODO Introduction Financial Services LLC:",
    introductionBody:
      "(SCA Lisans no: 20200000168), Birleşik Arap Emirlikleri Menkul Kıymetler ve Emtia Otoritesi (SCA) kapsamında yetkili ve tescilli bir limited şirkettir. GODO Limited (Mauritius) ile münhasır ortaklığı kapsamında yalnızca BAE vatandaşları ve sakinlerine hizmet sunar. Ancak GODO Introduction, müşteri varlıklarını veya parasını tutmaya yetkili değildir; tüm hizmetler yalnızca tanıtım esasına göre sağlanır.",
  },
  toast: {
    success: "Başarı bildirimi",
    info: "Bilgi bildirimi",
    warning: "Uyarı bildirimi",
    error: "Hata bildirimi",
    dismiss: "Bildirimi kapat",
    reviewFields: "Lütfen işaretli alanları kontrol edip tekrar deneyin.",
    registerSuccess: "Teşekkürler. Kaydınız alındı.",
    submitError:
      "Kaydınız tamamlanamadı. Lütfen tekrar deneyin. Sorun devam ederse destek ekibiyle iletişime geçin.",
    alreadyClient:
      "Bu e-posta veya telefon numarası zaten müşteri olarak kayıtlı. Lütfen mevcut kullanıcı olarak devam edin.",
    alreadyExists:
      "Bu e-posta veya telefonla bir hesap zaten var. Uygunluğunuzu kontrol etmek için Mevcut Kullanıcı seçeneğini kullanın.",
    documentsRequired:
      "Göndermeden önce kimlik belgesinin ön ve arka yüzünü ile adres belgesini yükleyin.",
    kycCheckError: "KYC durumu kontrol edilemedi. Lütfen tekrar deneyin.",
    accountFound: "Hesabınız bulundu. İşlem hesabı bilgileriniz aşağıda gösterilir.",
    rateLimited: "Çok fazla deneme yapıldı. Lütfen biraz bekleyip tekrar deneyin.",
  },
  signup: {
    title: "Kayıt Ol",
    existingUser: "Mevcut Kullanıcı",
    newUser: "Yeni Kullanıcı",
    lead: "Devam etmek için bir seçenek belirleyin.",
    existingHint: "KYC durumunu kontrol etmek için hesabınızı girin",
    newHint: "Kayıt olmak için bilgilerinizi doldurun",
    back: "Geri",
    close: "Kaydı kapat",
    accountNumber: "Hesap Numarası",
    accountPlaceholder: "GODO hesap numaranızı girin",
    checkKyc: "KYC Durumunu Kontrol Et",
    checkingKyc: "Kontrol ediliyor…",
    registerNow: "Şimdi Kaydol",
    submitting: "Gönderiliyor…",
    reviewAndContinue: "Bilgileri gözden geçir",
    reviewTitle: "Bilgilerinizi kontrol edin",
    reviewLead:
      "Lütfen her şeyin doğru olduğunu kontrol edin. Değişiklik yapmak için geri dönebilir veya kaydı tamamlamak için onaylayabilirsiniz.",
    editDetails: "Bilgileri düzenle",
    confirmRegister: "Kaydı onayla",
    reviewDocuments: "Belgeler",
    viewFile: "Görüntüle",
    registerSuccessTitle: "Kayıt Alındı",
    registerSuccessLead:
      "Teşekkürler. Kaydınız alındı ve belgeleriniz KYC incelemesinde. Durumu daha sonra kontrol etmek için aşağıdaki hesap numaranızı saklayın.",
    alreadyExistsTitle: "Hesap zaten mevcut",
    alreadyExistsLead:
      "Bu e-posta veya telefon numarasıyla bir hesap zaten var. Yarışmaya ilginiz kaydedildi. Hesap bilgileriniz aşağıda gösterilir.",
    registerDone: "Tamam",
    fullName: "Ad Soyad (Pasaporttaki gibi)",
    fullNamePlaceholder: "Ad soyad girin",
    nickname: "Takma ad",
    nicknamePlaceholder: "ör. AlexTrader",
    nicknameHint: "3–16 karakter. Harf, rakam ve alt çizgi.",
    nicknameAvailable: "Takma ad kullanılabilir.",
    nicknameChecking: "Takma ad kontrol ediliyor…",
    nicknameSuggestions: "Bunlardan birini deneyin:",
    saveNickname: "Kaydet",
    savingNickname: "Kaydediliyor…",
    editNickname: "Düzenle",
    editDetailsLead: "Bilgilerinizi aşağıdan güncelleyin. Yalnızca değişen alanlar kaydedilir.",
    editDocumentsHint: "Yalnızca değiştirmek istediğiniz belgeleriyükleyin. Mevcut dosyaları korumak için boş bırakın.",
    cancel: "İptal",
    detailsSaved: "Bilgiler kaydedildi.",
    detailsUnchanged: "Kaydedilecek değişiklik yok.",
    nicknameSaved: "Takma ad kaydedildi.",
    nicknameBeforeKyc: "Önce takma adınızı seçin. KYC bilgileriniz kaydettikten sonra görünecek.",
    nicknameSavedWithEmail: "Takma ad kaydedildi. Onay e-postası gönderildi.",
    existingContactFound:
      "Bu e-posta veya telefon için mevcut bir hesap bulduk. Lütfen aşağıdaki eksik alanları tamamlayın. Şartlar ve yararlanıcı onayı yine zorunludur.",
    existingContactComplete:
      "Bu e-posta veya telefon için mevcut bir hesap bulduk. Devam etmek için şartları kabul edin ve yararlanıcı sahipliğini onaylayın.",
    checkingExisting: "Bilgileriniz kontrol ediliyor…",
    email: "E-posta Adresi",
    emailPlaceholder: "Geçerli e-posta girin",
    phone: "Telefon",
    countryOfResidence: "İkamet Ülkesi",
    nationality: "Uyruk",
    dualNationality: "Çift Uyruk",
    profession: "Meslek",
    sourceOfFunds: "Fon Kaynağı",
    proofOfIdentity: "Kimlik Belgesi",
    proofOfIdentityBack: "Kimlik Belgesi (Arka Yüz)",
    proofOfAddress: "Adres Belgesi",
    proofOfIdentityInfoLabel: "Kimlik belgesi gereksinimleri",
    proofOfAddressInfoLabel: "Adres belgesi gereksinimleri",
    usCitizen: "ABD vatandaşı mısınız?",
    yes: "Evet",
    no: "Hayır",
    hasCode: "Kodunuz var mı?",
    codePlaceholder: "Kodu girin",
    chooseFile: "Dosya seçin",
    typeHere: "Buraya yazın...",
    search: "Ara...",
    noResults: "Sonuç bulunamadı",
    specify: "{label} belirtin",
    searchLabel: "{label} ara",
    countryCodes: "Ülke kodları",
    select: "-- Seçin --",
    selectShort: "Seçin",
    notApplicable: "Uygulanamaz",
    approved: "Onaylandı",
    fullNameShort: "Ad Soyad",
    emailShort: "E-posta",
    phoneShort: "Telefon",
    country: "Ülke",
    detailsProfile: "Profil",
    detailsLocation: "Konum",
    detailsCompliance: "Uyum",
    beneficialOwnerShort: "Gerçek lehdar",
    termsAcceptedShort: "Koşullar kabul edildi",
    kycStatus: "KYC Durumu",
    kycApproved:
      "Tebrikler! KYC’niz onaylandı. Yarışmaya katılmaya uygunsunuz. İşlem hesabı bilgileri için e-postanızı kontrol edin veya cs@godocm.com ile iletişime geçin.",
    kycPending:
      "Henüz yarışmaya uygun değilsiniz. KYC onayını tamamlamak için lütfen cs@godocm.com adresiyle iletişime geçin.",
    kycPendingContactEmail: "cs@godocm.com",
    kycNotFound: "Bu numaraya ait hesap bulunamadı.",
    forgotAccount: "Hesap numaranızı mı unuttunuz?",
    forgotAccountTitle: "Hesabınızı bulun",
    recoverLead:
      "Hesap bilgilerinizi görüntülemek için GODO işlem hesabınıza bağlı e-posta veya telefon numarasını girin.",
    recoverByEmail: "E-posta",
    recoverByPhone: "Telefon",
    findAccount: "Hesabımı bul",
    recoverFound:
      "Hesabınız bulundu. İşlem hesap numaranız ve bilgileriniz aşağıda gösterilir.",
    recoverNotFound: "Bu bilgilerle hesap bulunamadı.",
    notApproved: "İncelemede",
    beneficialOwnerBefore:
      "Bu hesabın gerçek lehdarı ve yetkili yatırımcısı olduğumu onaylıyorum. Değilse, ",
    powerOfAttorney: "Vekaletname",
    beneficialOwnerAfter: " belgesini sunmuş bulunuyorum.",
    termsBefore:
      "Kaydı onaylayarak şunları onaylıyorum: (1) ",
    termsOfBusiness: "İş Koşullarını",
    termsAfter:
      " okudum, anladım ve kabul ediyorum, (2) GODO’nun makul saatlerde benimle iletişime geçmesine izin veriyorum ve (3) numaram DNCR (Arama Yapılmasın Kaydı) kapsamında kayıtlı değildir.",
    competitionTermsBefore: "",
    competitionTermsLink: "Yarışma Şartları ve Koşulları",
    competitionTermsAfter: "'nı okudum ve kabul ediyorum.",
    proofOfIdentityIntro:
      "Yasal adı, son kullanma tarihi geçmemiş olması, doğum tarihi, uyruk ve kayıtlı kimlik numarasını içeren belgelerden EN AZ BİRİNİ sunun:",
    proofOfIdentityItems: [
      "Pasaport - Herhangi bir uyruk için",
      "BAE mukimi ise Emirates kimliği",
      "Bu bilgileri içeren resmi bir kimlik belgesi",
    ],
    proofOfAddressIntro:
      "Başvuru formundaki mevcut veya daimi ikamet adresini gösteren ve son 3 takvim ayı içinde düzenlenmiş belgelerden EN AZ BİRİNİ sunun",
    proofOfAddressItems: [
      "Elektrik, su, gaz veya telefon gibi kamu hizmeti faturaları veya ekstraları",
      "Kira / kiralama sözleşmesi (sözleşme süresi içinde olmalıdır)",
      "Yerel veya ulusal resmi belgeler, belediye vergi kayıtları veya benzeri",
      "Tescilli tapu, kira veya kiralama sözleşmeleri",
      "Denetlenen finansal kuruluşlardan belgeler, banka ekstraları veya sigorta poliçeleri gibi.",
      "Kısa süreli kira veya paylaşımlı konutta kalanlar, uyruklarına ait daimi ikamet belgesi sunabilir.",
    ],
    professionOptions: {
      employed: "Ücretli çalışan",
      "self-employed": "Serbest meslek",
      "business-owner": "İşletme sahibi",
      student: "Öğrenci",
      management: "Yönetim",
      unemployed: "İşsiz",
      other: "Diğer",
    },
    fundsOptions: {
      salary: "Maaş",
      savings: "Tasarruf",
      pension: "Emeklilik",
      "profits-dividends": "Kâr / Temettü",
      "sale-of-assets": "Varlık satışı",
      "crypto-investments": "Kripto yatırımları",
      "inheritance-gifts": "Miras ve hediyeler",
      other: "Diğer",
    },
    errors: {
      accountRequired: "Lütfen hesap numaranızı girin.",
      accountInvalid: "Geçerli bir hesap numarası girin (4–20 harf veya rakam).",
      fullNameRequired: "Lütfen pasaporttaki tam adınızı girin.",
      fullNameShort: "Ad soyad en az 2 karakter olmalıdır.",
      fullNameLetters: "Ad soyad yalnızca harf, boşluk, tire ve kesme işareti içerebilir.",
      emailRequired: "Lütfen e-posta adresinizi girin.",
      emailInvalid: "Lütfen geçerli bir e-posta adresi girin.",
      phoneRequired: "Lütfen telefon numaranızı girin.",
      phoneInvalid: "Lütfen geçerli bir telefon numarası girin.",
      countryRequired: "Lütfen ikamet ülkenizi seçin.",
      countryNotEligible: "Bu yarışma yalnızca seçili ülkelerden katılıma açıktır. Mevcut konumunuz uygun değil.",
      nationalityRequired: "Lütfen uyruğunuzu seçin.",
      professionRequired: "Lütfen mesleğinizi seçin.",
      professionOther: "Lütfen mesleğinizi belirtin.",
      professionOtherLetters: "Meslek yalnızca harf ve boşluk içerebilir.",
      fundsRequired: "Lütfen fon kaynağınızı seçin.",
      fundsOther: "Lütfen fon kaynağınızı belirtin.",
      fundsOtherLetters: "Fon kaynağı yalnızca harf ve boşluk içerebilir.",
      identityRequired: "Lütfen kimlik belgesi yükleyin.",
      identityBackRequired: "Lütfen kimlik belgesinin arka yüzünü yükleyin.",
      addressRequired: "Lütfen adres belgesi yükleyin.",
      usCitizenRequired: "Lütfen ABD vatandaşı olup olmadığınızı seçin.",
      beneficialOwner: "Lütfen gerçek lehdar olduğunuzu onaylayın.",
      terms: "Devam etmek için koşulları kabul edin.",
      competitionTerms:
        "Devam etmek için yarışma şartlarını ve koşullarını okuyup kabul edin.",
      referral: "Lütfen kodunuzu girin.",
      referralInvalid: "Referans kodu yalnızca harf, rakam, tire ve alt çizgi içerebilir.",
      nicknameRequired: "Lütfen bir takma ad seçin.",
      nicknameLength: "Takma ad 3–16 karakter olmalıdır.",
      nicknameInvalid: "Harfle başlayın. Sonra yalnızca harf, rakam ve alt çizgi kullanın. Boşluk olamaz.",
      nicknameReserved: "Bu takma ad ayrılmış. Lütfen başka bir ad seçin.",
      nicknameTaken: "Bu takma ad alınmış. Lütfen başka bir ad seçin.",
      fileType: "Lütfen yalnızca JPEG, PNG, WEBP veya PDF dosyası yükleyin.",
      fileTooLarge: "Her dosya en fazla 10MB olabilir.",
      fileUploadFailed: "Dosya yükleme başarısız. Lütfen desteklenen bir dosyayla tekrar deneyin.",
    },
  },
};

export default tr;
